import { useLanguage } from '../store/LanguageContext';
import SEOHead from '../components/SEOHead';
import { BRAND } from '../config/brand';

// V5.36 (feedback mede-eigenaar): retour- & terugbetalingsbeleid met
// duidelijke termijnen — vereist voor o.a. Google Shopping en consumenten-
// vertrouwen. Teksten via t() in alle vier de talen; Filip kan de inhoud
// later verfijnen (BRAND-gegevens komen uit config/brand.ts).
export default function RetourPage() {
  const { t } = useLanguage();
  const blocks: Array<{ title: string; body: string }> = [
    { title: t('retour.s1.title'), body: t('retour.s1.body') },
    { title: t('retour.s2.title'), body: t('retour.s2.body') },
    { title: t('retour.s3.title'), body: t('retour.s3.body') },
    { title: t('retour.s4.title'), body: t('retour.s4.body') },
    { title: t('retour.s5.title'), body: t('retour.s5.body') },
  ];
  return (
    <div className="pt-16 md:pt-[72px] min-h-screen bg-white">
      <SEOHead page="retour" />
      <section className="relative h-[160px] md:h-[190px] flex items-center overflow-hidden text-white">
        <div className="absolute inset-0" style={{ backgroundImage: 'url(/products/misty-grijs.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }} />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/35" />
        <div className="relative z-10 max-w-3xl mx-auto px-4 w-full">
          <h1 className="text-3xl md:text-4xl font-bold" style={{ fontFamily: 'Playfair Display' }}>{t('retour.title')}</h1>
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-4 py-10">
        <p className="text-sm text-[#8a7e74] mb-8">{t('retour.intro')}</p>
        <div className="space-y-7">
          {blocks.map(b => (
            <section key={b.title}>
              <h2 className="text-lg font-bold text-[#1a1a1a] mb-1.5">{b.title}</h2>
              <p className="text-sm text-[#4a4a4a] leading-relaxed whitespace-pre-line">{b.body}</p>
            </section>
          ))}
        </div>
        <p className="mt-10 text-xs text-[#8a7e74] border-t border-gray-100 pt-4">
          {BRAND.name} · {BRAND.street}, {BRAND.postalCode} {BRAND.city} · {BRAND.email} · {t('retour.btw')} {BRAND.btw}
        </p>
      </div>
    </div>
  );
}
